<template src="./ComplianceByUser.html"></template>

<script>
import {
  tasksByUser,
  getCompliance,
  getWeeklyUser,
  getMonthlyCompliance,
  getAnnualCompliance,
  getUserComplianceCompanies,
  getComplianceByCompany,
  tasksByUserExcel,
  deleteTaskByCompany,
  getSubtasks,
  saveHoursReport,
  updateHoursReport,
  uploadFile,
} from "../../../services";
import { TASK_STATUS } from "../../../utils/constants";
import { mapGetters } from "vuex";
import {
  OnlyAdmin,
  AdminCompliance,
  NotClientCompliance,
  OnlyClientCompliance,
} from "../../../utils/roles";
import moment from "moment";
import Companies from "../../../components/Forms/Companies/Companies";
import { formatToTwoDecimals } from "../../../utils/computeds";
import { ROL } from "../../../services/roles";
import { companyStorageFolder } from "../../../utils/storage";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const emptySubtaskForm = () => ({
  activity: "",
  status: "Planeado",
  dateExecution: new Date().toISOString().substr(0, 10),
  plannedDate: new Date().toISOString().substr(0, 10),
  timeDestined: 0,
  assignedHours: 0,
  onSite: false,
  observation: "",
  documentFile: null,
});

export default {
  components: { Companies },
  data() {
    return {
      tasks: [],
      search: {
        companyId: null,
        activity: "",
        status: this.$route.query.status ?? "PLANNED",
        userId: null,
        startDate: null,
        endDate: null,
      },
      TASK_STATUS,
      skip: 0,
      take: 100,
      usersCompliance: [],
      weeklyData: {
        occupation: 0,
        currentWeek: 0,
        previousWeek: 0,
        twoWeeksAgo: 0,
        percentage: 0,
      },
      monthlyCompliance: 0,
      annualPlan: {
        planned: 0,
        executed: 0,
        inProgress: 0,
        compliance: 0,
        added: 0,
      },
      expanded: {},
      subtasksByTask: {},
      subtaskDialog: false,
      subtaskParent: null,
      subtaskForm: emptySubtaskForm(),
      savingSubtask: false,
      sortOrder: "asc",
      currentWeekNumber: 0,
      previousWeekNumber: 0,
      twoWeeksAgoNumber: 0,
      startDateMenu: false,
      endDateMenu: false,
      companies: [],
      disabled: false,
      companiesData: [],
    };
  },
  computed: {
    isStatus() {
      return (status) => this.search.status !== status;
    },
    ...mapGetters({
      user: "getUser",
    }),
    OnlyAdmin,
    AdminCompliance,
    NotClientCompliance,
    OnlyClientCompliance,
  },
  created() {
    this.setResponsible();
    this.searchTask();
    this.listUsersCompliance();
    // TODO:no llamar funciones para el rol admin
    this.loadWeeklyData();
    this.loadMonthlyCompliance();
    this.loadAnnualCompliance();
    this.listCompanies();

    if (this.user.rol === ROL.COMPANY_COMPLIANCE) {
      this.fetchCompaniesData(this.user.company.id);
    }
  },
  methods: {
    setResponsible() {
      if (
        this.user &&
        !this.OnlyAdmin(this.user.rol) &&
        !this.AdminCompliance(this.user.rol) &&
        this.NotClientCompliance(this.user.rol)
      ) {
        this.search.userId = this.user.id;
      } else {
        this.search.userId = null;
      }
    },
    async getTaskByStatus() {
      this.skip = 0;
      this.take = 100;
      this.disabled = false;
      await this.searchTask();
    },
    async searchTask(addTask = false) {
      try {
        if (!addTask) {
          if (
            !this.OnlyAdmin(this.user.rol) &&
            !this.AdminCompliance(this.user.rol) &&
            this.NotClientCompliance(this.user.rol)
          ) {
            this.search.userId = this.user.id;
          } else {
            this.search.userId = null;
          }

          if (this.user.rol === ROL.COMPANY_COMPLIANCE) {
            this.search.companyId = this.user.company.id;
          }
        } else {
          if (
            !this.OnlyAdmin(this.user.rol) &&
            !this.AdminCompliance(this.user.rol) &&
            this.NotClientCompliance(this.user.rol) &&
            !this.search.userId
          ) {
            this.search.userId = this.user.id;
          }

          if (
            this.user.rol === ROL.COMPANY_COMPLIANCE &&
            !this.search.companyId
          ) {
            this.search.companyId = this.user.company.id;
          }
        }

        const tasks = await tasksByUser(
          this.search.companyId,
          this.search.status,
          this.search.activity,
          this.search.userId,
          this.search.startDate,
          this.search.endDate,
          this.skip,
          this.take,
          this.sortOrder
        );

        const taskData = Array.isArray(tasks.data) ? tasks.data : [];

        if (!addTask) {
          this.tasks = taskData;
          this.expanded = {};
          this.subtasksByTask = {};
        } else {
          this.tasks.push(...taskData);
        }

        if (taskData.length < this.take) {
          this.disabled = true;
        }
      } catch (err) {
        console.log("search tasks:", err);
      }
    },
    async listUsersCompliance() {
      try {
        const userCompliance = await getCompliance();
        this.usersCompliance = userCompliance.map((user) => {
          user.fullname = `${user.name} ${user.lastName}`;
          return user;
        });
      } catch (err) {
        console.log("Error on list usersCompliance:", err);
      }
    },
    async manualSearchTask() {
      try {
        this.skip = 0;
        this.disabled = false;

        const tasks = await tasksByUser(
          this.search.companyId,
          this.search.status,
          this.search.activity,
          this.search.userId,
          this.search.startDate,
          this.search.endDate,
          this.skip,
          this.take,
          this.sortOrder
        );

        this.tasks = tasks.data;
        this.expanded = {};
        this.subtasksByTask = {};

        if (this.tasks.length < this.take) this.disabled = true;
        else this.disabled = false;
      } catch (err) {
        console.log("search tasks:", err);
      }
    },
    async loadWeeklyData() {
      try {
        const response = await getWeeklyUser(this.user.id);
        const {
          occupation,
          currentWeek,
          previousWeek,
          twoWeeksAgo,
          currentWeekNumber,
          previousWeekNumber,
          twoWeeksAgoNumber,
          percentage,
        } = response;

        this.weeklyData = {
          occupation,
          currentWeek,
          previousWeek,
          twoWeeksAgo,
          percentage,
        };

        this.currentWeekNumber = currentWeekNumber;
        this.previousWeekNumber = previousWeekNumber;
        this.twoWeeksAgoNumber = twoWeeksAgoNumber;
      } catch (error) {
        console.error("Error fetching weekly data:", error);
      }
    },
    async loadMonthlyCompliance() {
      try {
        const response = await getMonthlyCompliance(this.user.id);
        this.monthlyCompliance = response.monthlyCompliance;
      } catch (error) {
        console.error("Error fetching monthly compliance:", error);
      }
    },
    async loadAnnualCompliance() {
      try {
        const response = await getAnnualCompliance(this.user.id);
        const { planned, executed, inProgress, compliance, added } = response;
        this.annualPlan = { planned, executed, inProgress, compliance, added };
      } catch (error) {
        console.error("Error fetching annual compliance:", error);
      }
    },
    async toggleSubtasks(task) {
      const isExpanded = !!this.expanded[task.id];
      this.$set(this.expanded, task.id, !isExpanded);

      if (!isExpanded && !this.subtasksByTask[task.id]) {
        try {
          const response = await getSubtasks(task.id);
          this.$set(this.subtasksByTask, task.id, response.data);
        } catch (error) {
          console.error("Error fetching subtasks:", error);
        }
      }
    },
    async toggleSortOrder() {
      this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      this.skip = 0;
      this.disabled = false;
      await this.searchTask();
    },
    isWarning(plannedDate) {
      if (!plannedDate) return false;

      const today = moment().startOf("day");
      const date = moment(plannedDate).startOf("day");
      const diffInDays = date.diff(today, "days");
      return diffInDays <= 3 && diffInDays > 0;
    },
    isPastDue(plannedDate) {
      if (!plannedDate) return false;
      const today = moment().startOf("day");
      const date = moment(plannedDate).startOf("day");
      const diffInDays = date.diff(today, "days");
      return diffInDays <= 0;
    },
    openDocument(url) {
      window.open(url, "_blank");
    },
    async listCompanies() {
      try {
        if (this.user.rol === ROL.COMPANY_COMPLIANCE) {
          this.companies = this.user.company;
        } else {
          this.companies = await getUserComplianceCompanies();
        }
      } catch (err) {
        console.error("Error al listar las empresas:", err);
      }
    },
    updateCompany(id) {
      this.search.companyId = id;
    },
    manualFilterCleaning() {
      this.search = {
        companyId: null,
        activity: "",
        startDate: null,
        endDate: null,
        userId: null,
        status: this.search.status,
      };
      this.skip = 0;
      this.disabled = false;
      this.searchTask();
    },
    formatToTwoDecimals,
    async moreTask() {
      this.skip += this.take;
      this.disabled = false;
      await this.searchTask(true);
    },
    async fetchCompaniesData(companyId) {
      try {
        const response = await getComplianceByCompany(companyId);
        this.companiesData = response;
      } catch (error) {
        console.error(error);
      }
    },
    async downloadExcel() {
      try {
        const tasks = await tasksByUserExcel(
          this.search.companyId,
          this.search.status,
          this.search.activity,
          this.search.userId,
          this.search.startDate,
          this.search.endDate,
          0,
          100000,
          'desc'
        );

        if (!tasks.data.length) {
          this.$swal({
            text: "No hay tareas para descargar.",
            buttons: false,
            icon: "error",
            timer: 3000,
          });
          return;
        }

        const jsonData = tasks.data.map((task) => {
          return {
            Cliente: task.companyId.name,
            Usuario: `${task.userId.name} ${task.userId.lastName}`,
            Creado: task.createdAt,
            Tipo: task.parentTaskId ? "Subactividad" : "Actividad",
            "Actividad Padre": task.parentTaskId ? task.parentTaskId.activity : "",
            Estado: task.status,
            Actividad: task.activity,
            "Horas Asignadas": task.assignedHours,
            "Fecha de Ejecución": task.dateExecution,
            "Fecha Planeada": task.plannedDate,
            Presencial: task.onSite === true ? "Si" : "No",
            Documento: task.documentAssociated,
            Guia: task.guide,
            "Horas Ejecutadas": task.timeDestined,
            "Semana de Ejecución": task.weekExecution,
            Año: task.currentYear,
            "Plan de cumplimiento": task.planTask === true ? "Si" : "No",
            Observacion: task.observation,
          };
        });
        const worksheet = XLSX.utils.json_to_sheet(jsonData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Tareas");
        const excelBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
        const data = new Blob([excelBuffer], {
          type: "application/octet-stream",
        });
        saveAs(data, "Tareas cumplimiento.xlsx");
      } catch (error) {
        console.error("Error al descargar el archivo Excel:", error);
        this.$swal({
          text: "Ocurrio un error, intenta mas tarde.",
          buttons: false,
          icon: "error",
          timer: 3000,
        });
      }
    },
    async confirmSoftDeleteTask(task) {
      try {
        const result = await this.$swal({
          title: "¿Está seguro de eliminar la tarea?",
          text: "Esta acción no se puede deshacer.",
          icon: "warning",
          buttons: ["Cancelar", "Eliminar"],
          dangerMode: true,
        });
        if (result) {
          await this.softDeleteTask(task);
        }
      } catch (error) {
        console.error("Error confirming task deletion:", error);
      }
    },
    async softDeleteTask(task) {
      try {
        await deleteTaskByCompany(task.id);
        this.$swal({
          text: "Tarea eliminada correctamente.",
          buttons: false,
          icon: "success",
          timer: 3000,
        });
        this.searchTask();
      } catch (error) {
        console.error("Error while deactivating and deleting the task:", error);
        this.$swal({
          text: "Ocurrió un error al eliminar la tarea. Inténtelo de nuevo más tarde.",
          buttons: false,
          icon: "error",
          timer: 3000,
        });
      }
    },
    openReportHours(task) {
      const taskKey = `reportTask_${task.id}_${Date.now()}`;
      sessionStorage.setItem(taskKey, JSON.stringify(task));

      const route = this.$router.resolve({
        name: 'Reportar Horas',
        query: { taskKey }
      });
      window.open(route.href, '_blank');
    },
    getWeekNumber(d) {
      const date = new Date(d.getTime());
      const dayOfWeek = date.getUTCDay() === 0 ? 7 : date.getUTCDay();
      date.setUTCDate(date.getUTCDate() + 4 - dayOfWeek);
      const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
      const firstThursday = new Date(
        yearStart.setUTCDate(yearStart.getUTCDate() + (4 - (yearStart.getUTCDay() || 7)))
      );
      const diffInDays = (date - firstThursday) / 86400000;
      return Math.ceil((diffInDays + 1) / 7);
    },
    mapSubtaskStatusToDB(status) {
      const statusMapping = {
        Planeado: 'PLANNED',
        'En Progreso': 'IN_PROGRESS',
        Ejecutado: 'EXECUTED'
      };
      return statusMapping[status];
    },
    mapSubtaskStatusFromDB(status) {
      const statusMapping = {
        PLANNED: 'Planeado',
        IN_PROGRESS: 'En Progreso',
        EXECUTED: 'Ejecutado'
      };
      return statusMapping[status] || 'Planeado';
    },
    openAddSubtask(task) {
      this.subtaskParent = task;
      this.subtaskForm = emptySubtaskForm();
      this.subtaskDialog = true;
    },
    openEditSubtask(parentTask, subtask) {
      this.subtaskParent = parentTask;
      this.subtaskForm = {
        id: subtask.id,
        activity: subtask.activity,
        status: this.mapSubtaskStatusFromDB(subtask.status),
        dateExecution: subtask.dateExecution
          ? subtask.dateExecution.substring(0, 10)
          : new Date().toISOString().substr(0, 10),
        plannedDate: subtask.plannedDate
          ? moment(subtask.plannedDate).format('YYYY-MM-DD')
          : new Date().toISOString().substr(0, 10),
        timeDestined: subtask.timeDestined || 0,
        assignedHours: subtask.assignedHours || 0,
        onSite: subtask.onSite || false,
        observation: subtask.observation || "",
        documentFile: null,
        documentAssociated: subtask.documentAssociated || null,
        companyId: subtask.companyId,
        userId: subtask.userId,
      };
      this.subtaskDialog = true;
    },
    closeSubtaskDialog() {
      this.subtaskDialog = false;
      this.subtaskParent = null;
      this.subtaskForm = emptySubtaskForm();
    },
    async saveSubtask() {
      if (!this.subtaskParent) return;

      if (!this.subtaskForm.activity) {
        this.$swal({
          text: "Debe llenar el campo actividad",
          buttons: false,
          icon: "warning",
          timer: 3000,
        });
        return;
      }

      const isEdit = !!this.subtaskForm.id;
      this.savingSubtask = true;
      try {
        let documentAssociated = this.subtaskForm.documentAssociated;
        if (this.subtaskForm.documentFile) {
          const companyName = isEdit
            ? this.subtaskForm.companyId.name
            : this.subtaskParent.companyId.name;
          documentAssociated = await uploadFile(
            companyStorageFolder(companyName),
            `${Date.now()}-${this.subtaskForm.documentFile.name}`,
            this.subtaskForm.documentFile
          );
        }

        const payload = {
          activity: this.subtaskForm.activity,
          dateExecution: this.subtaskForm.dateExecution,
          onSite: this.subtaskForm.onSite,
          timeDestined: Math.round(Number(this.subtaskForm.timeDestined) * 60),
          assignedHours: Math.round(Number(this.subtaskForm.assignedHours) * 60),
          weekExecution: this.getWeekNumber(new Date(this.subtaskForm.dateExecution)),
          planTask: false,
          plannedDate: new Date(this.subtaskForm.plannedDate),
          status: this.mapSubtaskStatusToDB(this.subtaskForm.status),
          observation: this.subtaskForm.observation,
        };
        if (documentAssociated) payload.documentAssociated = documentAssociated;

        if (isEdit) {
          payload.id = this.subtaskForm.id;
          payload.userId = this.subtaskForm.userId.id;
          payload.companyId = this.subtaskForm.companyId.id;
          await updateHoursReport(payload);
        } else {
          payload.userId = this.subtaskParent.userId.id;
          payload.companyId = this.subtaskParent.companyId.id;
          payload.parentTaskId = this.subtaskParent.id;
          await saveHoursReport(payload);
        }

        this.closeSubtaskDialog();
        this.$swal({
          text: isEdit
            ? "Subactividad actualizada correctamente."
            : "Subactividad creada correctamente.",
          buttons: false,
          icon: "success",
          timer: 3000,
        });
        await this.searchTask();
      } catch (error) {
        console.error("Error saving subtask:", error);
        this.$swal({
          text: "Ocurrió un error al guardar la subactividad. Inténtelo de nuevo más tarde.",
          buttons: false,
          icon: "error",
          timer: 3000,
        });
      } finally {
        this.savingSubtask = false;
      }
    },
  },
};
</script>

<style lang="scss" src="./ComplianceByUser.scss" scoped></style>
